import React from 'react'
import { FaCalendarAlt } from 'react-icons/fa'
import { Avatar, CircularProgress } from '@nextui-org/react'
import CircularProgressComponent from '../CircularProgressComponent'


const GorevlerCardComponent = (props) => {
  const { title, description, date, deadline, priority, isPrivate, status, member, onClick } = props
  

  const getPriotityText = (priority) => {
    switch (priority) {
      case 1:
        return 'Çok Düşük'
      case 2:
        return 'Düşük'
      case 3:
        return 'Normal'
      case 4:
        return 'Yüksek'
      case 5:
        return 'Çok Yüksek'
      default:
        return ''
    }
  }

  const priorityText = getPriotityText(priority)

  // Kullanıcı fotoğrafı veya baş harf için
  const getUserDisplay = () => {
    if (member.member_img && member.member_imgtype) {
      return (
        <Avatar
          src={process.env.NEXT_PUBLIC_USERIMG + member.member_img + '.' + member.member_imgtype}
          className="border-[1px] h-6 w-6"
        />
      )
    } else {
      // Baş harf göster
      const initials = member.member_name
        .split(' ')
        .map(name => name.charAt(0))
        .join('')
        .toUpperCase()
        .slice(0, 2)
      
      return (
        <div className="h-6 w-6 rounded-full bg-gray-400 flex items-center justify-center text-white text-xs font-semibold border-[1px]">
          {initials}
        </div>
      )
    }
  }

  // Deadline tarihini formatla
  const formatDeadline = (deadline) => {
    if (!deadline) return null
    const date = new Date(deadline)
    return date.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })
  }

  // Deadline durumuna göre renk belirle
  const getDeadlineColor = (deadline) => {
    if (!deadline) return { color: 'text-gray-500', iconColor: 'text-gray-500' }
    
    const today = new Date()
    const deadlineDate = new Date(deadline)
    const diffTime = deadlineDate - today
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    
    if (diffDays < 0) {
      // Geçmiş tarih - kırmızı
      return { color: 'text-red-500', iconColor: 'text-red-500' }
    } else if (diffDays <= 3) {
      // 3 gün veya daha az - turuncu
      return { color: 'text-orange-600', iconColor: 'text-orange-600' }
    } else {
      // Uzak tarih - yeşil
      return { color: 'text-green-500', iconColor: 'text-green-500' }
    }
  }

  return (
    <div
      className={`relative hover:translate-y-[-5px] cursor-pointer transition-all hover:duration-500 hover:shadow-md rounded-[6px] w-full h-[200px] ${
        status === 'Tamamlandı' ? 'bg-[#ECECEC] dark:bg-[#1D1D1D]' : 'dark:bg-dark-300 bg-white'
      }`}
      onClick={isPrivate === false && onClick}
    >
      <h2 className="text-base font-semibold ml-8 pt-5 text-gray-900 dark:text-white">{title}</h2>

      {isPrivate ? (
        priorityText && <p className="ml-8 text-xs font-light text-[#999] dark:text-gray-400 mt-1">Öncelik: {priorityText}</p>
      ) : (
        <p className="ml-8 text-xs font-light text-[#999] dark:text-gray-400 mt-1">{status}</p>
      )}
      <div className="absolute left-4 bottom-5 ml-4 gap-3 flex flex-col items-start">
        {isPrivate === false && (
          <div className={`flex flex-row items-center gap-2 ${isPrivate ? 'hidden' : 'block'}`}>
            {getUserDisplay()}
            <p className="text-sm text-gray-900 dark:text-white">{member.member_name}</p>
          </div>
        )}

        <div className="flex flex-col items-start gap-1">
            {formatDeadline(deadline) && (
              <div className="flex flex-row items-center">
                <FaCalendarAlt className={`${getDeadlineColor(deadline).iconColor} text-sm`} />
                <p className={`ml-2 text-xs ${getDeadlineColor(deadline).color} dark:${getDeadlineColor(deadline).color} font-medium`}>
                  Teslim: {formatDeadline(deadline)}
                </p>
              </div>
            )}
        </div>
      </div>

      <div className="absolute bottom-6 right-4 flex items-center gap-2 flex-col">
        <CircularProgressComponent items={{ priority, width: '40px', height: '40px' }} />
        {isPrivate === false && <p className="text-xs font-light text-[#999] dark:text-gray-400 mt-1">{priorityText}</p>}
      </div>
    </div>
  )
}

export default GorevlerCardComponent
